export const STATISTICS_CONSTANTS = {
  MAX_DATE_RANGE_YEARS: 5,
  DEFAULT_DATE_RANGE_MONTHS: 1,
  MOBILE_CHART_HEIGHT: 250,
  DESKTOP_CHART_HEIGHT: 400,
  
  // Performance thresholds
  LARGE_DATASET_THRESHOLD: 50, // Reduce animation duration above this
  VERY_LARGE_DATASET_THRESHOLD: 100, // Disable animations above this
  ANIMATION_DURATION_FAST: 200,
  ANIMATION_DURATION_NORMAL: 400,
  
  TAB_TYPES: {
    CHART: 'chart' as const,
    JOURNALS: 'journals' as const,
    ACCOUNTS: 'accounts' as const,
  },
} as const;